.img-container{width:59%;float:left}.audio-container{width:400px;height:50px;background-color:#f1f1f1;border-radius:25px;margin:10px 0}.audio-container img{margin:0 auto;display:block}
/*# sourceMappingURL=audio.component-5QY4ORKZ.css.map */
